import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=fcdd6c40&scoped=true"
import script from "./ImageCarousel.vue?vue&type=script&lang=js"
export * from "./ImageCarousel.vue?vue&type=script&lang=js"
import style0 from "./ImageCarousel.vue?vue&type=style&index=0&id=fcdd6c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdd6c40",
  null
  
)

export default component.exports